import dayjs from "dayjs";
import _ from "lodash";
import { OrderItemHelper } from "../OrderItemHelper";
import { formatKitchenTableAlias } from "~/utils/kitchenTableLabel";
import { JobAction } from "~/interface/Job";
export default class PrintJobNiceloopV1Builder extends OrderItemHelper {
    private job: any = null;

    constructor(productsStore: any) {
        super(productsStore);
    }

    // create method to build receipt
    build() {
        return this.job;
    }

    getCurrentDateTime() {
        return dayjs().format('YYYY-MM-DDTHH:mm:ssZ');
    }

    makePrintJobKitchen(_payload: any) {
        const employeeName = _payload?.employee?.name || _payload?.employee?.Name || "unknown"
        const tableLabel = _payload.nickName || formatKitchenTableAlias(_payload.alias)
        this.job = {
            // The structure sent to the legacy printer service carries ONLY
            // CustomerCount (string) — no `Guest`. Sourced from the gated guest
            // count (printJobToKitchen sets options.guests = 0 when Customer mode
            // is off), so it is emitted only when there are guests to show.
            ...(Number(_payload?.guests) > 0 ? { CustomerCount: String(_payload.guests) } : {}),
            // showPrice rides in on the caller's options (printJobToKitchen) —
            // the builder stays free of store access.
            OrderItems: this.buildOrderItems(_payload?.json?.orderitems, { showPrice: _payload?.showPrice === true }),
            Table: tableLabel,
            // Prefer the PC receive time (cashier's server-synced clock) over the
            // originating device's `timestamp` — a terminal/mobile clock can be
            // wrong, so the kitchen slip must show when the CASHIER received the
            // order. Cashier-origin jobs have no pcTimestamp → falls back to their
            // own timestamp (same clock). Mirrors computeJobchain's sort key.
            DateTime: dayjs(_payload.pcTimestamp || _payload.timestamp).format('YYYY-MM-DDTHH:mm:ssZ'),
            Date: dayjs(_payload.pcTimestamp || _payload.timestamp).format('YYYY-MM-DDTHH:mm:ssZ'),
            OrderTaker: employeeName,
            Comments: _payload?.note || _payload?.comments || "",
            WaterMark: "",
            IsVoid: false,
            IsHideQtyComboSet: false,
            Reference: tableLabel,
            UniqueId: _payload.jobId,
            // UniqueId: `ketchen_${new Date().valueOf().toString()}_${_payload.alias}`,
            ShopId: _payload.storeId,
            ServiceValue: _payload.serviceValue,
            VatValue: _payload.vatValue,
            VatMode: _payload.vatMode,
            AccumulateGrandTotal: 0,
            PreviousGrandTotal: 0,
            noOfJobs: "#1"
        };

        return this
    }

    makePrintJobVoid(_payload: any) {
        const employeeName = _payload?.employee?.name || _payload?.employee?.Name || "unknown"
        const tableLabel = _payload?.nickName || formatKitchenTableAlias(_payload?.alias)
        // json2 carries the per-uuid void qty (negative). Override each line's qty
        // with the voided amount so the kitchen slip shows 1 (not the full 4) on a
        // partial void. Fall back to the full line qty only when an entry is absent.
        const json2: Record<string, number> = (_payload?.json2 as any) || {}
        // A topping void keeps the item — say so on every row, or the kitchen
        // reads "ชาเย็น (ไข่มุก)" as the whole drink being cancelled.
        const isToppingOnly = _payload?.type === JobAction.VOID_TOPPING
        const voidItems = (Array.isArray(_payload.__items) ? _payload.__items : []).map((it: any) => ({
            ...it,
            ...(isToppingOnly ? { name: `${it.name || ''} (ยกเลิกเฉพาะ Topping)` } : {}),
            quantity: Math.abs(Number(json2[it.uuid] ?? 0)) || Number(it.quantity || 0),
        }))
        this.job = {
            customercount: _payload.guests || 2,
            uniqueid: _payload.jobId,
            // uniqueid: `void_items_${
            //     new Date().valueOf().toString()
            // }`,
            username: employeeName,
            by: employeeName,
            table: `${tableLabel} (ยกเลิก)`,
            datetime: this.getCurrentDateTime(),
            uuid: _payload.uuid,
            customermode: 1,
            fullAlias: _payload.alias,
            alias: _payload.alias,
            comments: _payload?.comments,
            useZoneV2: true,
            orderitems: this.buildOrderItems(voidItems),
            reference: `${tableLabel} (ยกเลิก)`,
            orderTaker: employeeName,
            watermark: "Void\nยกเลิก",
            isPrint: true,
            approvedBy: employeeName,
            isVoid: true,
            read: 2,
            customfooters: [
                {
                    name: "PrintTextLine",
                    value: `\nReason :   ${_payload?.__reason
                        }`
                }, {
                    name: "LineFeed",
                    value: ""
                }, {
                    name: "PrintTextLine",
                    value: "Sign :   "
                }
            ],
            date: this.getCurrentDateTime()
        };

        return this
    }

    makePrintJobMove(_payload: any) {
        const employeeName = _payload?.employee?.name || _payload?.employee?.Name || "unknown"
        const printerList = this.getPrintersListFromItems(_payload.__items)
        const printers = printerList.flat()
        console.log("printers move", printers)
        const header = [
            {
                quantity: "0",
                name: "**   หากมีรายการค้าง",
                Comments: "",
                tags: printers
            },
            {
                quantity: "0",
                name: `**   ย้ายจากโต๊ะ ${_payload.alias} ==> ${_payload.newAlias}`,
                Comments: "",
                tags: printers
            },
            {
                quantity: "0",
                name: "**   (ย้ายบางรายการ ดังนี้)",
                Comments: "",
                tags: printers
            },

        ]
        this.job = {
            OrderItems: [
                //  ...header,
                ...this.transfromMoveOrderItems(_payload.__items, _payload.alias, _payload.newAlias)
            ],
            IsMoveTable: true,
            IsReprint: true,
            Date: this.getCurrentDateTime(),
            OrderTaker: employeeName,
            UniqueId: `${_payload.jobId}:move`,
            ShopId: _payload.storeId,
            Table: `${formatKitchenTableAlias(_payload.alias)} ย้ายไป ${formatKitchenTableAlias(_payload.newAlias)}`,
            Reference: `${formatKitchenTableAlias(_payload.alias)} ย้ายไป ${formatKitchenTableAlias(_payload.newAlias)}`
        };

        return this

    }

    makeReprintJobToKitchen(payload: any) {
        // Same rule as the kitchen ADD slip: show the PC receive time, not the
        // originating device's clock. Falls back to timestamp when pcTimestamp absent.
        const printTs = payload.pcTimestamp || payload.timestamp
        const time = dayjs(printTs).format('HH:mm')
        const tableLabel = payload.nickName || formatKitchenTableAlias(payload.alias)
        this.job = {
            "OrderItems": this.buildOrderItems(payload?.json?.orderitems, { showPrice: payload?.showPrice === true }),
            "Table": `${tableLabel} (ตามอาหาร)`,
            "DateTime": `${dayjs(printTs).format('YYYY-MM-DDTHH:mm:ssZ')}`,
            "Date": `${dayjs(printTs).format('YYYY-MM-DDTHH:mm:ssZ')}`,
            "OrderTaker": payload.by || "unknown",
            "Comments": "************************\n***  RE-PRINT : \n***   สั่งไปแล้วเมื่อ  " + time + "\n************************\n\n",
            "WaterMark": "",
            "IsVoid": false,
            "Reference": `Table  ${tableLabel}`,
            "UniqueId": `reprint_${new Date().valueOf().toString()}`,
            "ShopId": payload.storeId,
        }

        return this
    }
}
